import React from 'react';
import TopBar from '@/Components/TopBars/TopBar';
import { ClientsOverviewContextProvider } from './contexts/ClientsOverviewContext';
import ClientsOverviewHeader from './components/ClientsOverviewHeader';
import ClientsOverviewCards from './components/ClientsOverviewCards';

const ClientsOverviewPage = () => (
    <ClientsOverviewContextProvider>
        <div className="bg-background flex h-dvh flex-col">
            <TopBar />
            <main className="min-h-0 flex-1 overflow-auto">
                <ClientsOverviewHeader />
                <div className="container mx-auto px-6 py-10 sm:px-8">
                    <ClientsOverviewCards />
                </div>
            </main>
        </div>
    </ClientsOverviewContextProvider>
);

export default ClientsOverviewPage;
